import type { SVGProps } from "react";
const SvgAverageSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={33}
    height={33}
    fill="none"
    {...props}
  >
    <g clipPath="url(#Average_SVG_svg__a)">
      <path stroke="#2b385f" d="M5 18.5h23" />
      <path
        fill="#CFD7E4"
        stroke="#2b385f"
        d="M4.5 18.5h24v16h-24zM4.5-.5h24v19h-24z"
      />
      <path fill="#D2D2D2" fillOpacity={0.84} d="M4-1h25v36H4z" />
      <circle cx={16.5} cy={16.5} r={6} fill="#fff" stroke="#2b385f" />
    </g>
    <defs>
      <clipPath id="Average_SVG_svg__a">
        <path fill="#fff" d="M0 0h33v33H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgAverageSvg;
